<template>
  <form-wrapper>
    <b-form @submit="submit">
      <h2 class="text-center">
        Create a new group
      </h2>
      <b-form-group>
        <label for="name-input">Name</label>
        <b-form-input
          v-validate="'required'"
          id="name-input"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('name') || apiErrors.name.length }"
          :value="fields.name"
          class="form-control"
          type="text"
          name="name"
          @input="setName"/>
        <validation-errors :validation-errors="[errors.first('name')]"/>
        <validation-errors v-if="!errors.has('name')" :validation-errors="apiErrors.name"/>
      </b-form-group>

      <b-form-group>
        <label for="description-input">Description</label>
        <b-form-textarea
          v-validate="'required'"
          id="description-input"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('description') || apiErrors.description.length }"
          :rows="3"
          :max-rows="6"
          :value="fields.description"
          type="text"
          name="description"
          @input="setDescription"/>
        <validation-errors :validation-errors="[errors.first('description')]"/>
        <validation-errors v-if="!errors.has('description')" :validation-errors="apiErrors.description"/>
      </b-form-group>

      <relate-modules
        ref="relateModules"
        :initial-modules="[]"
        :disabled="saving"
        namespace="groups"/>

      <relate-members
        ref="relateMembers"
        :initial-members="[]"
        :disabled="saving"
        namespace="groups"/>

      <b-form-group class="form-buttons">
        <b-button :disabled="disabled" type="submit" variant="primary">
          Confirm
          <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
        </b-button>
      </b-form-group>

      <form-success :success="success" class="form-alert">
        Group Created!
      </form-success>
    </b-form>

  </form-wrapper>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import formSuccess from '../../../common/form/form-success'
import formWrapper from '../../../common/form/form-wrapper'
import relateModules from '../modules/relateModules'
import relateMembers from '../members/relateMembers'
import validationErrors from '../../../common/form/validation-errors'

export default {
  components: {
    formSuccess,
    formWrapper,
    relateModules,
    relateMembers,
    validationErrors
  },
  computed: {
    ...mapState('groups/forms/store', [
      'apiErrors',
      'fields',
      'success',
      'saving'
    ]),
    disabled () {
      return this.errors.any() || this.saving
    }
  },
  watch: {
    success (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.resetFields()
      }
    }
  },
  methods: {
    ...mapActions({
      storeGroup: 'groups/store',
      relateMedia: 'groups/relateMedia'
    }),
    submit (event) {
      event.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.storeGroup()
        }
      })
    },
    setName (event) {
      this.$store.commit('groups/forms/store/setField', {
        field: 'name',
        value: event
      })
    },
    setDescription (event) {
      this.$store.commit('groups/forms/store/setField', {
        field: 'description',
        value: event
      })
    },
    reset (event) {
      this.errors.clear()
      this.$refs.relateModules.reset()
      this.$refs.relateMembers.reset()
    },
    resetFields (event) {
      this.reset()
      this.$store.commit('groups/forms/store/resetFields')
    },
    resetForm (event) {
      this.reset()
      this.$store.commit('groups/forms/store/resetState')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/groups/add.vue